// extracted by mini-css-extract-plugin
export default {"Panel":"Panel_Panel__onGAE","GeyItems":"Panel_GeyItems__fPjWa"};